<template>
	<view class="floating-label-wrapper flex-1" @tap="handleWrapperTap">
		<view :class="['label', isFocused || value ? 'active' : '' ]">
			<text>{{ props.label }}</text>
			<text v-if="props.required" class="text-[#FF4D4F]">*</text>
		</view>
		<view class="input-container">
			<view class="flex-1">
				<up-input ref="inputRef" :focus="shouldFocused" v-if="showInput" :clearable="props.clearable"
					:type="props.type" border="none" customStyle="flex:1;height:40rpx;padding: 34rpx 20rpx 4rpx;"
					:disabled="props.disabled" :formatter="formatPrice" v-model="value" :maxlength="props.maxlength"
					@focus="onFocus" @blur="onBlur" @change="onChange">
					<template #prefix>
						<slot name="prefix">{{ props.prefixText }}</slot>
					</template>
				</up-input>
			</view>
			<view v-if="props.suffixText || $slots.suffix" class="suffix">
				<slot name="suffix">{{ props.suffixText }}</slot>
			</view>
		</view>
	</view>
</template>

<script setup>
	import {
		ref,
		reactive,
		defineProps,
		defineEmits,
		onMounted,
		computed,
		nextTick
	} from 'vue'

	const props = defineProps({
		type: {
			type: String,
			default: "text",
		},
		label: {
			type: String,
			default: "",
		},
		modelValue: {
			type: [String, Number],
			default: "",
		},
		maxlength: {
			type: [String, Number]
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		prefixText: String,
		suffixText: {
			type: String,
		},
		limit2: {
			type: Boolean,
			default: false
		},
		clearable: {
			type: Boolean,
			default: false
		},
		showInput: {
			type: Boolean,
			default: true
		},
		formatter: Function
	})

	const emit = defineEmits(["update:modelValue", "focus", "blur", "change"])

	const value = computed({
		get: () => {
			return props.modelValue
		},
		set: (v) => {
			emit('update:modelValue', v)
		}
	})

	const inputRef = ref(null)
	const shouldFocused = ref(null)
	const handleWrapperTap = async () => {
		if (props.disabled || !props.showInput) return
		isFocused.value = true
		shouldFocused.value = true
	}

	const formatPrice = (val) => {
		if (!val) return ''
		if(props.formatter) return props.formatter(val)
		if (!props.limit2) return val
		const v = val.replace(/[^0-9.]/g, '').replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2')
		return v
	}

	const isFocused = ref(false)

	const onFocus = () => {
		emit("focus")
	}

	const onBlur = () => {
		isFocused.value = false
		shouldFocused.value = false
		emit("blur")
	}

	const onChange = (v) => {
		emit("change", v)
	}
</script>

<style lang="scss">
	.floating-label-wrapper {
		flex: 1;
		position: relative;
		border-bottom: 2rpx solid #eee;
	}

	.floating-label-wrapper .label {
		display: flex;
		align-items: flex-end;
		position: absolute;
		top: 50%;
		left: 10px;
		z-index: 10;
		color: #808080;
		transform: translateY(-16rpx);
		transition: all 0.3s ease;
		pointer-events: none;
	}

	.floating-label-wrapper .active {
		top: 16rpx;
		font-size: 22rpx;
		color: #808080;
	}

	.input-container {
		display: flex;
		align-items: flex-end;
		min-height: 80rpx;
	}

	.suffix,
	.prefix {
		padding-bottom: 12rpx;
		color: #aaa;
	}

	.prefix {
		padding-bottom: 0;
	}
</style>